import Cabecalho from "../../components/Cabecalho";
import Navbar from "../../components/Navbar/Navbar";
import styles from "./styles.module.css";
import { useLocation } from "react-router-dom";
import ShowPlanoDeTrabalho from "../../components/ShowPlanoDeTrabalho";

const ContextoPlanoDeTrabalho = () => {
  const location = useLocation();
  const planoDeTrabalho = location.state.planoDeTrabalho;
  const metasFisicas = location.state.metasFisicas;
  const metasAplicacoes = location.state.metasAplicacoes;
  const metasAplicacaoRecurso = location.state.metasAplicacaoRecurso;
  const receitasDespesas = location.state.receitasDespesas;
  const equipamentos = location.state.equipamentos;

  return (
    <div className={styles.page}>
      <Navbar activeIndex={1} />
      <section>
        <Cabecalho title="Meus Planos de Trabalho" icon="document" />
        <main>
          <div className={styles.container}>
            <div>
              <ShowPlanoDeTrabalho
                descricao={planoDeTrabalho}
                metaFisica={metasFisicas}
                metasAplicacoes={metasAplicacoes}
                metasAplicacaoRecurso={metasAplicacaoRecurso}
                receitasDespesas={receitasDespesas}
                equipamentos={equipamentos}
              />
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default ContextoPlanoDeTrabalho;
